module.exports = __webpack_public_path__ + "static/img/invite.3620990e.png";